const primaryDark = '#2266CC';
const primary = '#2B80FF';
const secondary = '#F4F9FF';
const dark = '#1C1C1C';
const darkGrey = '#999999';
const light = '#FFFFFF';
const success = '#34a853';
const error = '#EA4335';
const warning = '#FBBC05';

const warningLight = '#FFFAEE';
const errorLight = '#FCF4F5';
const successLight = '#F1F9F3';

const grey = '#4F4F4F';
const greyLight = '#EEE';
const disabled = '#D1D3D4';
const background = '#E8E8E8';

const transparent = 'rgba(0, 0, 0, 0)';

const avatarBackground = '#F4F9FF';

export default {
  primaryDark,
  primary,
  secondary,
  dark,
  darkGrey,
  light,
  success,
  error,
  warning,

  warningLight,
  errorLight,
  successLight,

  grey,
  greyLight,
  disabled,
  background,

  transparent,

  avatarBackground,
};
